import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageRecipientReferrals from '@/components/v2/survey/PageRecipientReferrals';
import SurveyRespondentEmailVerification from './SurveyRespondentEmailVerification';
import SurveyRespondentOtpVerification from './SurveyRespondentOtpVerification';
let RaffleTaskRespondentDetails = class RaffleTaskRespondentDetails extends Vue {
    get generalDetailsHeaders() {
        return {
            totalPoints: 'Earned Entries',
            referralCode: 'Referral Code',
        };
    }
    get completerUuid() {
        return this.respondent.uuid;
    }
};
__decorate([
    Prop({ type: Object, default: null })
], RaffleTaskRespondentDetails.prototype, "respondent", void 0);
RaffleTaskRespondentDetails = __decorate([
    Component({
        components: {
            SurveyRespondentEmailVerification,
            SurveyRespondentOtpVerification,
            PageRecipientReferrals,
        },
    })
], RaffleTaskRespondentDetails);
export default RaffleTaskRespondentDetails;
